import generalState from 'src/store/general'
import wordingState from 'src/store/modules/wording'

export default function () {
  const { lang } = generalState.state()
  const wording = wordingState.state

  return {
    table: {
      so: {
        columns: [
          {
            name: 'so_no',
            field: row => {
              return `<a href="/po/detail/${row.id}/${encodeURIComponent(row.po_no)}?from=${encodeURIComponent(window.location.pathname)}" class="goto-preview-page"><strong>${row.po_no}</strong></a>`
              // return row.so_no
            },
            label: 'Nomor PO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary text-no-wrap'
          },
          {
            name: 'vendor',
            field: row => {
              return row.supplier_name
              // return '?'
            },
            label: 'Vendor',
            sortable: true,
            align: 'left',
            rowClass: 'text-left td-width-small'
          },
          {
            name: 'created_at',
            field: 'po_date',
            label: 'Tanggal PO',
            sortable: true,
            align: 'left',
            commonDate: true
          },
          {
            name: 'finished_at',
            field: 'estimate_date',
            label: 'Estimasi Pengiriman',
            sortable: true,
            align: 'left',
            commonDate: true
          },
          {
            name: 'billing_date',
            field: 'billing_date',
            label: 'Tanggal Penagihan',
            sortable: true,
            align: 'left',
            commonDate: true
          },
          {
            name: 'quantity',
            field: row => {
              return row.qty + ' produk'
            },
            label: 'Jumlah Pembelian',
            sortable: true,
            align: 'left'
          },
          {
            name: 'total',
            field: row => {
              return 'Rp' + row.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            label: 'Total Pembelian',
            sortable: true,
            align: 'left'
          },
          {
            name: 'status',
            field: 'status',
            format: val => {
              const status = wording[lang].poStatus[val]
              if (val && status) {
                const badgeClass = val !== 'CANCELED' ? 'green' : 'red'
                return `
                  <div role="alert" class="custom-badge custom-badge-${badgeClass}">
                    ${status}
                  </div>
                `
              }

              return '-'
            },
            label: 'Status Pengiriman',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          }
        ]
      },

      form: {
        products: {
          columns: [
            {
              name: 'produk',
              field: row => {
                const html = `
                  <div class="flex">
                    <img src="${row.images[0].src}"
                      alt=""
                      class=""
                      style="width: 56px; height: 56px;"
                      >
                    <div class="flex column text-caption q-ml-md">
                      <strong>${row.title}</strong>
                      <div>No. SKU: ${row.sku}</div>
                      <a
                        href="javascript: void(0)"
                        class="open-note"
                        data-note="${row.note}"
                        >
                        lihat Catatan
                      </a>
                    </div>
                  </div>
                `
                return html
              },
              label: 'Produk',
              sortable: true,
              align: 'left',
              rowClass: 'text-left'
            },
            {
              name: 'shippingAt',
              field: 'shippingAt',
              label: 'Tanggal Kirim Barang',
              sortable: true,
              align: 'center',
              rowClass: 'text-center'
            },
            {
              name: 'price',
              field: 'price',
              label: 'Harga Jual',
              sortable: true,
              align: 'center',
              rowClass: 'text-center'
            },
            {
              name: 'qty',
              field: 'qty',
              label: 'Jumlah',
              sortable: true,
              align: 'center',
              rowClass: 'text-center'
            }
          ]
        }
      }
    }
  }
}
